import themeConfig from '@themeConfig'
import v2Themes from '@/styles/v2/tokens'

require('./overrides.scss')

// Skins
require('./skins/bordered.scss')
require('./skins/semi-dark.scss')

// Read at boot, same as the dark-mode flag below, so a user who's opted into v2 sees the
// right colors on first paint instead of a flash of classic colors before useAppConfig runs.
const isV2 = localStorage.getItem('schooldash-ui-version') === 'v2'

export default {
  theme: {
    themes: isV2 ? { ...v2Themes } : { ...themeConfig.themes },
    dark:
      localStorage.getItem('materio-active-theme') === null
        ? themeConfig.app.isDark
        : localStorage.getItem('materio-active-theme') === 'dark',
  },
  rtl: themeConfig.app.isRtl,
}
